var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("line",{"y1":"0.591752","x2":"6","y2":"0.591752","stroke":"#F5F2F2","strokeWidth":"0.816497"}));
}

Minus.defaultProps = {"width":"6","height":"1","viewBox":"0 0 6 1","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
